import React, { SetStateAction } from 'react'
import { Button } from '../../../../../common/components/button/Button'
import { Input } from '../../../../../common/components/input/Input'
import { ExecutorInterface } from '../../../../../common/types/interfaces'
import classes from './Form.module.sass'
import { useForm } from './hooks/useForm'
import { Toggle } from '../../../../../common/components/toggle/Toggle'
import { SearchSelect } from '../../../../../common/components/searchSelect/SearchSelect'
import { SearchGroupSelect } from '../../../../../common/components/searchGroupSelect/SearchGroupSelect'

type Props = {
  edit: boolean
  data: ExecutorInterface
  setData: React.Dispatch<SetStateAction<ExecutorInterface>>
  getList: () => void
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  el?: ExecutorInterface
}

export const Form = ({ edit, data, setData, getList, setModalActive, el }: Props) => {
  const {
    formAction,
    inputHandler,
    setDirty,
    getValidationResult,
    disabled,
    createMotivationSelectList,
    createStoreSelectList,
    handleStoreSelect,
    handleStoreRemove,
    storeValue,
  } = useForm(data, setData, edit, getList, setModalActive, el)

  return (
    <div className={classes.container}>
      <div className={classes.tabContent}>
        <Input
          type={'text'}
          fieldName={'name'}
          value={data.name}
          placeHolder={'Имя исполнителя'}
          onChangeHandler={inputHandler}
          itemValidationResult={getValidationResult('name')}
          onBlur={setDirty}
        />
        <Input
          type={'text'}
          fieldName={'phone_number'}
          value={data.phone_number}
          placeHolder={'Телефон'}
          onChangeHandler={inputHandler}
          itemValidationResult={getValidationResult('phone_number')}
          onBlur={setDirty}
        />
        <Input
          type={'text'}
          fieldName={'position'}
          value={data.position || ''}
          placeHolder={'Должность (любой текст)'}
          onChangeHandler={inputHandler}
          itemValidationResult={getValidationResult('position')}
          onBlur={setDirty}
        />

        <SearchSelect
          onBlur={setDirty}
          fieldName="motivationId"
          options={createMotivationSelectList()}
          value={data.motivationId}
          onChangeHandler={inputHandler}
          type="text"
          placeholder="Выберите мотивацию"
          itemValidationResult={getValidationResult('motivationId')}
        />

        <SearchGroupSelect
          onBlur={setDirty}
          fieldName="storeIds"
          options={createStoreSelectList()}
          value={storeValue}
          onChangeHandler={(value) => {
            if (value === '' || value === undefined) return
            handleStoreSelect(Number(value))
          }}
          onRemoveHandler={(value) => handleStoreRemove(Number(value))}
          type="array"
          placeholder="Выберите точки"
          itemValidationResult={getValidationResult('storeIds')}
        />
        {!data.userId && (
          <>
            <div className={classes.toggleContainer}>
              <Toggle
                id="publish"
                onChange={() => setData((prev) => ({ ...prev, publish: !prev.publish }))}
                checked={data.publish}
              />
              <div>Публиковать на портале</div>
            </div>

            <div className={classes.toggleContainer}>
              <Toggle
                id="publishMotivation"
                onChange={() =>
                  setData((prev) => ({ ...prev, publishMotivation: !prev.publishMotivation }))
                }
                checked={data.publishMotivation}
              />
              <div>Показывать мотивацию в публикации</div>
            </div>
          </>
        )}

        <div className={classes.toggleContainer}>
          <Toggle
            id="isDriver"
            onChange={() => setData((prev) => ({ ...prev, isDriver: !prev.isDriver }))}
            checked={data.isDriver}
          />
          <div>Перевозчик</div>
        </div>

        <div className={classes.toggleContainer}>
          <Toggle
            id="canServe"
            onChange={() => setData((prev) => ({ ...prev, canServe: !prev.canServe }))}
            checked={data.canServe}
          />
          <div>Обслуживает клиентов</div>
        </div>

        <div className={classes.toggleContainer}>
          <Toggle
            id="trackLocation"
            onChange={() => setData((prev) => ({ ...prev, trackLocation: !prev.trackLocation }))}
            checked={data.trackLocation}
          />
          <div>Трекинг геолокации</div>
        </div>

        <div className={classes.toggleContainer}>
          <Toggle
            id="isActive"
            onChange={() => setData((prev) => ({ ...prev, isActive: !prev.isActive }))}
            checked={data.isActive}
          />
          <div>Активен</div>
        </div>
      </div>

      <Button text={edit ? 'Сохранить' : 'Добавить'} onClick={formAction} disabled={disabled} />
    </div>
  )
}
